import React,{useState,useEffect} from 'react';
import Header from '../../components/common/Header';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';
import LoaderImg from '../../assets/images/loader.gif'
import { useNavigate,useLocation, useParams,useSearchParams} from 'react-router-dom';
import { getSelectedDetail,getStudentFee, salesforceSendFormNumber, uploadPaymentStatus } from '../../actions/StudentAction';
import {Link} from 'react-router-dom'
import queryString from 'query-string';
import { sendMastercardPayInfo } from '../../actions/MasterCardAction';
import swal from 'sweetalert';
import moment from 'moment';

const MastercardPaymentSuccessful = (props) => {
    const navigate = useNavigate();
    const useParam = useParams();
    const location=useLocation();
    const [detail,setDetail] = useState();
    const [loading,setLoading] = useState(true)
    const [feeDetail,setFeeDetail] = useState({});
    const qParams = queryString.parse(location.pathname + location.search);
    const {installment_amount,installment_amount_local,installments_id,net_payable_amount,net_payable_amount_local,scholarship_amount,scholarship_amount_local,installments_number,total_fee_local,total_fee,scholarship_percentage,actual_inst_amt,actual_inst_amt_local,lumpsum_amount_local,lumpsum_amount}=feeDetail
    const currentDate = moment().format('YYYY-MM-DD');


    const amount = useParam.paytype !== undefined && useParam?.paytype == 1 ? installment_amount :lumpsum_amount
    const amount_local = useParam.paytype !== undefined && useParam?.paytype == 1 ? installment_amount_local : lumpsum_amount_local


    window.addEventListener("beforeunload", function(e){
      e.preventDefault();
   }, false);

      useEffect(async()=>{
      await  getSelectedDetail(useParam?.id).then((res) => {
              setLoading(true)
            if(res.status){
                setDetail(res.data);
            }
        });

       await getStudentFee(useParam?.id, useParam?.paytype).then(res => {
          setFeeDetail(res.data)
          
      });

    },[useParam?.id,useParam?.paytype])
  let userFeeDetail = detail?.feeDetail
  // let receivedAmount = userFeeDetail?.paid_amount


    const uploadMastercardData = () => {
      setLoading(true)
      const dataRes = {
        student_id: useParam?.id,
        amount: parseFloat(amount).toFixed(2),
        local_amount: parseFloat(amount_local).toFixed(2),
        pay_transaction_id: qParams.resultIndicator,
        transaction_date: currentDate,
        payment_type: "Mastercard",
        payment_mode: "Online",
        scholarship_amount: scholarship_amount !==undefined && scholarship_amount,
        local_scholarship_amount: scholarship_amount_local !==undefined && scholarship_amount_local ,
        net_payable_amount: net_payable_amount !==undefined && net_payable_amount,
        local_net_payable_amount: net_payable_amount_local !==undefined && net_payable_amount_local,
        installments_id: installments_id !==undefined && installments_id,
        scholarship_percentage: scholarship_percentage !==undefined && scholarship_percentage,
        actual_inst_amt : actual_inst_amt !==undefined &&  actual_inst_amt,
        local_actual_inst_amt : actual_inst_amt_local !==undefined && actual_inst_amt_local,
        course_fee: total_fee !==undefined && total_fee,
        local_course_fee: total_fee_local !==undefined && total_fee_local,
        fee_type:useParam?.paytype,
        transaction_status:'COMPLETED',
        installments_number: installments_number !==undefined &&  installments_number,
    }

        uploadPaymentStatus(dataRes).then((res) => {
         
          if(res.status){
            setLoading(false)
            salesforceSendFormNumber({form_num:detail?.form_num,status:'payment_approved'})
            swal('Congratulations Your fee submited successfully.','','success')
            navigate('/dashboard', { state: {detail:detail !==undefined && detail } });
          }
          
      })
    }

    useEffect(async() => {
    
      if((feeDetail.installment_amount !== null && feeDetail.installment_amount !== undefined) || (feeDetail.lumpsum_amount !== null && feeDetail.lumpsum_amount !== undefined)){
        console.log(feeDetail.total_fee)
        await uploadMastercardData()
      }
      
    },[feeDetail])


 
  return (
     <>
      {loading ? <div className="screenLoader text-center flex-wrap">
      <img src={LoaderImg} alt="Loading..." style={{width:'140px'}}/>
      <span className='d-block w-100 fw-bold text-center'>Please wait while your payment processing</span>
      </div>:
      <>
      <Header detail={detail}/>
      <section className="pt-5 pb-5 content-section">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="register-box py-5">
                        <div className='allenAccountDetaiWrap border p-3 mb-4 rounded text-center'>
                            {/* <h4 className='mb-3'>𝐓𝐀𝐋𝐋𝐄𝐍𝐓𝐄𝐗 𝐎𝐯𝐞𝐫𝐬𝐞𝐚𝐬 𝟐𝟎𝟐𝟑</h4> */}
                            <h5 className='text-success fw-bold text-center mt-4'>Congratulations Your fee amount submited successfully.</h5>
                        </div>
                    
                    </div>
                </div>
            </div>
        </div>
        </section>
    </>
      }
    </>
    
  )
}

export default MastercardPaymentSuccessful
